(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-enochill"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-enochill [data-faq-list]').forEach((list) => {
    const items = list.querySelectorAll('details.faq-enochill__item');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach((other) => { if (other !== item) other.open = false; });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-enochill"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoEnochill(scope) {
      (scope || document).querySelectorAll('.video-enochill [data-video-wrapper]').forEach(function (wrapper) {
        if (wrapper.dataset.videoReady === '1') return;
        wrapper.dataset.videoReady = '1';

        var playBtn = wrapper.querySelector('[data-video-play]');
        var poster = wrapper.querySelector('[data-video-poster]');
        var player = wrapper.querySelector('[data-video-player]');
        if (!playBtn || !player) return;

        playBtn.addEventListener('click', function () {
          // El vídeo (nativo o YouTube/Vimeo) está en un <template>: se inyecta solo al pulsar
          var template = player.querySelector('[data-video-embed]');
          if (template) {
            player.appendChild(template.content.cloneNode(true));
            template.remove();
          }
          player.hidden = false;
          if (poster) poster.style.display = 'none';

          var nativeVideo = player.querySelector('video');
          if (nativeVideo) {
            nativeVideo.play().catch(function () {});
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initVideoEnochill(); });
    } else {
      initVideoEnochill();
    }
    document.addEventListener('shopify:section:load', function (e) { initVideoEnochill(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
